// extracted by mini-css-extract-plugin
export var animationContainer = "_fv-0";
export var asteriskIcon = "_fv-8";
export var conversationLeftSection = "_fv-4";
export var conversationListItem = "_fv-3";
export var conversationMiddleSection = "_fv-5";
export var conversationRightSection = "_fv-6";
export var detailsContent = "_fv-1";
export var listContainer = "_fv-7";
export var modalContent = "_fv-2";